import React from 'react';
import { Whisper, Popover } from 'rsuite';
import { useNavigate } from 'react-router-dom';
import {
  MdOutlineVisibility,
  MdOutlineUpdate
} from 'react-icons/md';

import {
  useLazyGetFullPrescriptionDetailsQuery,
  useLazyGetPrescriptionDetailsByPatientQuery
} from '../../State/Api/AddPrescriptionApiSlice';

const ActionCellDrPrescription = (props) => {
  const row = props?.data;
  const userClinicId = localStorage.getItem("userClinicID");
  const navigate = useNavigate();

  const [getPrescriptionDetails] = useLazyGetFullPrescriptionDetailsQuery();
  const [getPrescriptionDetailsByPatient] = useLazyGetPrescriptionDetailsByPatientQuery();

  const handleViewPrescription = async () => {
    try {
      const result = await getPrescriptionDetails({
        userUniqueID: row?.userUniqueID,
        appointmentID: row?.appointmentID,

      });

      if (result?.data) {
        navigate(`/DoctorPrescriptionDetails/${row?.userUniqueID}/${row?.appointmentID}`, {
  state: { details: result.data },
});
      }
    } catch (err) {
      console.error("Error fetching prescription details", err);
    }
  };

  const handleEditPrescription = async () => {
    try {
      const result = await getPrescriptionDetailsByPatient({
        userUniqueID: row?.userUniqueID,
        appointmentID: row?.appointmentID,
      });
      if (result?.data) {
        navigate("/prescriptionform", {
          state: { editData: result.data },
        });
      }
    } catch (err) {
      console.error("Error fetching prescription details by patient", err);
    }
  };

  const renderPopover = (
    <Popover arrow={false} full className="p-2 rounded-md w-42">
      <div className="px-3 pt-2 pb-1 text-sm font-bold text-gray-800">
        Actions
      </div>

      <div
        onClick={handleViewPrescription}
        className="flex items-center gap-2 px-3 py-2 text-sm text-gray-700 cursor-pointer hover:bg-gray-100 rounded-md"
      >
        <MdOutlineVisibility className="text-lg text-gray-500" />
        <span>View details</span>
      </div>

      <div
        onClick={handleEditPrescription}
        className="flex items-center gap-2 px-3 py-2 text-sm text-gray-700 cursor-pointer hover:bg-gray-100 rounded-md"
      >
        <MdOutlineUpdate className="text-lg text-gray-500" />
        <span>Edit</span>
      </div>
    </Popover>
  );

  return (
    <Whisper placement="autoVerticalEnd" trigger="click" speaker={renderPopover}>
      <button
        className="inline-flex items-center justify-center gap-2 w-10 h-10 rounded-md hover:bg-gray-100"
        title="More actions"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="lucide lucide-ellipsis h-4 w-4"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          viewBox="0 0 24 24"
        >
          <circle cx="12" cy="12" r="1" />
          <circle cx="19" cy="12" r="1" />
          <circle cx="5" cy="12" r="1" />
        </svg>
      </button>
    </Whisper>
  );
};

export default ActionCellDrPrescription;
